import React, { Fragment } from 'react';
import { Col, Glyphicon, Label, Row } from 'react-bootstrap';
import { IMedicalRecordAllele } from '@nkr/models/hla/hla-medical-record-allele';

interface IProps {
    antigenName: string,
    dropdownValue: boolean,
    dropdownName: string,
    alleles?: IMedicalRecordAllele[],
    hasAlleleData: boolean,
    title: string,
    equivalentSignedOff: boolean,
    handleBooleanChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

const rowStyle = {
    border: '1px solid #e7f1fa',
    borderRadius: '5px',
    padding: '6px',
    margin: '4px 2px',
    display: 'flex',
    alignItems: 'center',
    minHeight: 78
};

const titleColStyle = {
    backgroundColor: '#e7f1fa',
    borderRadius: '5px',
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '-6px 0 -6px -6px',
    paddingLeft: 8,
    paddingRight: 8,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
};

export const HlaDrb345ToggleForm = (props: IProps) => {
    const discrepancyLabel  = props.equivalentSignedOff ? 'warning' : 'danger';
    const booleanToString   = (value: boolean) => {
        switch (value) {
            case null: return 'null';
            case true: return 'true';
            case false: return 'false';
        }
    }
    

    return (
        <>
            <Col xs={12} lg={12}>
                <Row style={rowStyle}>
                    {/* 1st column - Title */}
                    <Col xs={1} lg={1} style={titleColStyle}>
                        <label htmlFor={props.title}>{props.title}</label>
                    </Col>

                    {/* 2nd column - Antigen */}
                    <Col xs={4} lg={4}>
                        <label htmlFor={props.antigenName}>
                            {props.antigenName + " Antigen?"}
                        </label>
                        <select
                            id={props.dropdownName}
                            name={props.dropdownName}
                            className="form-control"
                            value={booleanToString(props.dropdownValue)}
                            onChange={props.handleBooleanChange}
                        >
                            <option value="null">Unknown</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </Col>
                    <Col xs={2} lg={2}>
                        <label htmlFor={props.antigenName}>
                            Expected?
                        </label>
                        <br />
                    {!props.hasAlleleData ? '--' :
                        (() => {
                            let expected = props.alleles?.some(x => x.isExpressed);
                            let selected = props.dropdownValue;
                            return (
                                <Label
                                    bsStyle={expected == selected ? 'success' : discrepancyLabel}
                                    style={{
                                        fontSize: "14px",
                                        padding: "5px 10px",
                                        display: "inline-block"
                                    }}
                                >
                                    {expected ? 'Yes' : 'No'}
                                </Label>
                            );
                        })()
                    }
                    </Col>

                    {(() => {
                        const filtered = props.alleles?.filter(a => a.alleleDetail.startsWith(props.title)) ?? [];
                        return [0, 1].map(idx => {
                            const a = filtered[idx];
                            return (
                                <Fragment key={`slot-${idx}`}>
                                <Col xs={2} lg={2}>
                                    <label>Allele {idx + 1}</label>
                                    <br />
                                    {a ? (
                                        <Label
                                            bsStyle={a.isExpressed ? 'info' : 'default'}
                                            style={{
                                                fontSize: "14px",
                                                padding: "5px 10px",
                                                display: "inline-block"
                                            }}
                                        >
                                            {a.alleleDetail}
                                        </Label>
                                    ) : (
                                        <span style={{ color: '#999', fontStyle: 'italic', fontSize: 12 }}>—</span>
                                    )}
                                </Col>
                                </Fragment>
                            );
                        });
                    })()}

                    <Col xs={1} lg={1}>&nbsp;</Col>

                </Row>
            </Col>
        </>
    )
}